import { Box } from "@mui/material";

import AppDatePicker from "./AppDatePicker";

export default function DateRangeFields({
    value = [null, null],
    onChange,
    startLabel = "From",
    endLabel = "To",
    size = "small",
    sx,
}) {
    const [start, end] = value || [null, null];

    const handleChange = (index, nextValue) => {
        const nextRange = index === 0 ? [nextValue, end] : [start, nextValue];
        onChange?.(nextRange);
    };

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                gap: 1,
                ...sx,
            }}
        >
            <AppDatePicker
                label={startLabel}
                value={start}
                onChange={(nextValue) => handleChange(0, nextValue)}
                maxDate={end || undefined}
                size={size}
            />
            <AppDatePicker
                label={endLabel}
                value={end}
                onChange={(nextValue) => handleChange(1, nextValue)}
                minDate={start || undefined}
                size={size}
            />
        </Box>
    );
}
